import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FilterFlyoutIconName,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const InvoiceProcessFlow = () => {
  const {t} = useTranslation();

  return (
    <IconsFlow>
      <FlowStep>
        <Icon asset={GenericIconName.ParcelBox} size="S" />
        <FlowLabel>{t('Order')}</FlowLabel>
      </FlowStep>
      <ArrowWrapper>
        <Icon asset={GenericIconName.ArrowLongRight} size="SS" />
      </ArrowWrapper>
      <FlowStep>
        <Icon asset={FilterFlyoutIconName.Shirt} size="S" />
        <FlowLabel>{t('Try')}</FlowLabel>
      </FlowStep>
      <ArrowWrapper>
        <Icon asset={GenericIconName.ArrowLongRight} size="SS" />
      </ArrowWrapper>
      <FlowStep>
        <Icon asset={GenericIconName.BestPriceGuaranteeWallet} size="S" />
        <FlowLabel>{t('Pay')}</FlowLabel>
      </FlowStep>
    </IconsFlow>
  );
};

const IconsFlow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const FlowStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;

const FlowLabel = styled.span`
  font-size: 13px;
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 1.2;
  color: ${COLORS.Black};
  letter-spacing: -0.26px;
`;

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
`;
